var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImpressionslarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.33a4.33 4.33 0 1 1 0-8.66 4.33 4.33 0 0 1 0 8.66Zm0-7.16a2.83 2.83 0 1 0 0 5.67 2.83 2.83 0 0 0 0-5.67Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.02c-3.76 0-7.31-2.2-9.75-6.02a6.06 6.06 0 0 1 0-6c2.45-3.82 6-6.02 9.75-6.02s7.3 2.2 9.74 6.02a6.06 6.06 0 0 1 0 6c-2.44 3.82-5.99 6.02-9.74 6.02Zm0-16.54c-3.23 0-6.32 1.94-8.48 5.33a4.54 4.54 0 0 0 0 4.38c2.16 3.39 5.25 5.33 8.48 5.33 3.23 0 6.32-1.94 8.48-5.33a4.54 4.54 0 0 0 0-4.38C18.32 6.42 15.23 4.48 12 4.48Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImpressionslarge);
export default __webpack_public_path__ + "static/media/impressions.large.512e52b481b0cc2eb3500bb3e627b2f9.svg";
export { ForwardRef as ReactComponent };